import React from 'react';
import Auth from '../../services/auth';

export class CaptchaToken extends React.Component {


  componentDidMount() {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?onload=onLoadCallback&render=explicit';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);


window.onLoadCallback = () => {
    window.grecaptcha.render('g-recaptcha-container', {
      sitekey: process.env.REACT_APP_CAPCTHA_SITE_KEY,
      callback: (data)=>{
           this.props.setCaptchaToken(data);},
          'expired-callback':  () => {this.props.setCaptchaToken(null);},
        type: 'image'
    });
    if (this.props.onLoad) { this.props.onLoad(); }
  };
}

  componentWillUnmount() {
    const script = document.querySelector('script[src="https://www.google.com/recaptcha/api.js?onload=onLoadCallback&render=explicit"]');
    document.body.removeChild(script);
    delete window.onLoadCallback;
  }

  render() {
    return <div id="g-recaptcha-container"></div>;
  }


}
